import React from 'react';
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { ChevronDownIcon } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';
import styles from './ProjectsToolbar.module.scss';

interface FilterMenuProps {
    label: string;
    active: boolean;
    wide?: boolean;
    title?: string;
    children: (close: () => void) => ReactNode;
}

export function FilterMenu({ label, active, wide, title, children }: FilterMenuProps) {
    const [open, setOpen] = useState(false);
    const root = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return undefined;

        const onPointerDown = (event: MouseEvent) => {
            if (!root.current?.contains(event.target as Node)) setOpen(false);
        };
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') setOpen(false);
        };

        document.addEventListener('mousedown', onPointerDown);
        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('mousedown', onPointerDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [open]);

    return (
        <div className={cx(styles.filter, open && styles.open)} ref={root}>
            <button
                type="button"
                title={title}
                className={cx(styles.trigger, active && styles.set)}
                aria-expanded={open}
                onClick={() => setOpen((value) => !value)}
            >
                <span className={styles.cur}>{label}</span>
                <ChevronDownIcon className={styles.caret} />
            </button>

            {open && (
                <div className={cx(styles.menu, wide && styles.wide)}>{children(() => setOpen(false))}</div>
            )}
        </div>
    );
}